module.exports = function (fox) {
	"use strict";

	require('./stylus/_user-access-index.styl');
	require('fox-dynamic-injection!fox-template-loader!./templates/user-access.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!./templates/oneclick-upgrade.tpl')(fox);

	var require__options = require.context('./options', true, /\.opt$/);
	var option__files = require__options.keys();

	option__files.forEach(function (file) {
		require__options(file)(fox);
	});

	require('./widget/permissionManager')(fox);
	require('./widget/upgradeBanner')(fox);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/index.js
// module id = 799
// module chunks = 4